module.exports = '1.1.4';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = 469
// module chunks = 0 1 2 3 4 12